import angular from 'angular';
import { capitalize } from 'lodash';

module.exports = angular.module('common.filters.capitalize', [])
.filter('capitalize', () => capitalize)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/capitalize.js
 **/